module.exports = __webpack_public_path__ + "img/abdomen.b89c3d5c.svg";